/**
 * Discovery Controller Module
 * Handles Discovery page initialization
 *
 * Following OOA/OOD principles:
 * - Single Responsibility: Only discovery page logic
 * - Delegation: Delegates to DCMS Discovery module
 */

import { PageName } from '../types/page-types';
import { BaseController, ControllerServices } from './base-controller';

/**
 * DiscoveryController class
 * Manages the discovery page
 */
export class DiscoveryController extends BaseController {
    constructor(services: ControllerServices) {
        super(services);
    }

    getPageName(): PageName {
        return 'discovery';
    }

    protected async doInit(): Promise<void> {
        this.setupDiscoveryForms();
        this.loadDiscoveryHistory();
    }

    /**
     * Setup discovery form handlers
     */
    private setupDiscoveryForms(): void {
        // Discovery forms are handled by dcms-discovery.ts module
        // This is a hook for any additional setup
        const dcmsDiscovery = (window as any).dcmsDiscovery;
        if (dcmsDiscovery) {
            console.log('DCMS Discovery module available');
        }
    }

    /**
     * Load discovery history
     */
    private loadDiscoveryHistory(): void {
        // Discovery history is managed by the dcms-discovery module
        // This is a hook for any additional history loading
    }

    protected setupEventListeners(): void {
        // Delegate to dcms-discovery module for event handling
        // Additional page-level listeners can be added here
    }
}
